import * as React from 'react';
/**
 *
 * Original name: Kakao Talk
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=47663%3A13203
 *
 */
export const KakaoTalkExternalLogo = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 10.808C4 7.324 7.582 4.5 12 4.5s8 2.824 8 6.308c0 3.483-3.582 6.307-8 6.307-.485 0-.96-.034-1.42-.099-.463.325-3.13 2.199-3.381 2.234 0 0-.103.04-.191-.012-.088-.051-.072-.187-.072-.187.026-.18.691-2.476.814-2.899C5.497 15.036 4 13.06 4 10.808Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
